export default __webpack_public_path__ + "static/media/closet2-480w.65292cde.avif";